export interface PitchTypeOption {
  label: string;
  value: string;
}

export const BASEBALL_PITCH_TYPES: PitchTypeOption[] = [
  { label: "4S", value: "Fastball" },
  { label: "2S", value: "Sinker" },
  { label: "CT", value: "Cutter" },
  { label: "CH", value: "Changeup" },
  { label: "CB", value: "Curveball" },
  { label: "SL", value: "Slider" },
  { label: "SP", value: "Splitter" },
  { label: "KN", value: "Knuckleball" },
];

export const SOFTBALL_PITCH_TYPES: PitchTypeOption[] = [
  { label: "FB", value: "Fastball" },
  { label: "DB", value: "Dropball" },
  { label: "RB", value: "Riseball" },
  { label: "CB", value: "Curveball" },
  { label: "SB", value: "Screwball" },
  { label: "LR", value: "LowRise" },
  { label: "CH", value: "Changeup" },
  { label: "DC", value: "DropCurve" },
];
